export enum Currencies {
  USD = "USD",
  EUR = "EUR",
}

export const CURRENCIES_SIGNS: Record<Currencies, string> = {
  [Currencies.USD]: "$",
  [Currencies.EUR]: "€",
};
